import React from 'react'
import { CloseIcon } from '../../assets/svg'
import './styles.css'

class Modal extends React.Component {
  render() {
    return (
      <div className={`modalbg ${this.props.shown ? 'shown' : ''}`} onClick={ this.props.closeModal }>
        <div className="close-button" onClick={this.props.closeModal}><CloseIcon/></div>
        <div className={ `viewlift-modal modal-cover ${this.props.className} ${this.props.shown ? 'show' : 'dont-show'}` }>
          <div className="modal" onClick={ e => e.stopPropagation() }>
            <div className="modal-body">
              { this.props.children }
            </div>
            {this.props.showButtons? 
              <div className="modal-buttons">
                <button className="button button-no cta" onClick={this.props.closeModal}>NO</button>
                <button className="button button-yes cta" onClick={this.props.clear}>YES </button>
              </div>
            : ''
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Modal